import Field from 'cerebral-module-forms/Field'

export default function handlePopulateOptionsForStatePath({ state, input }) {
  const { source, destination } = input.populateOptionsForStatePath
  let { options, isRequired, type, isMultiple } = state.get(`${source}`)
  state.set(
    `${destination}`,
    Field({
      value: [],
      options: options.map((option, index) => {
        return {
          ...option,
          index,
          selected: false,
          filterIndex: null
        }
      }),
      filteredOptions: null,
      isRequired,
      type,
      isMultiple
    })
  )
}



// WEBPACK FOOTER //
// ./src/modules/client/actions/handlePopulateOptionsForStatePath.js